<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms" ref="isnowcom"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      newtestdata: "", //原始数据
    };
  },
  components: {
    //在线练习组卷都引用在onlinetestpaper

    CertifiedHosp: () => import("./components/page.vue"),
    TheApproved: () => import("./components/newaddpaper/index.vue"),
    TheEditor: () => import("./components/editorpaper/index.vue"),
    //  Encryption: () => import("./components/encryption/setEncryption.vue"),
    //   DecryTable: () => import("./components/encryption/decryTable.vue"),
    // ModifyThe: () => import("../../layout/components/userCenter/index.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "TheApproved";
        case 2:
          return "TheEditor";
        // case 3:
        //   return "Encryption";
        // case 4:
        //   return "DecryTable";
        // case 5:
        //   return "ModifyThe";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      if (index == "0" && this.isActive == "1") {
        //这里代表新增返回
        // console.log('新增返回');
        this.$children[0].Buriedpoint({
          code: "OnlineTest:Papers:add",
          parent_code: "OnlineTest:Papers",
        });
      } else if (index == "0" && this.isActive == "2") {  // 编辑
        this.$children[0].Buriedpoint({
          code: "OnlineTest:Papers:edit",
          parent_code: "OnlineTest:Papers",
        });
      }
      this.isActive = index;
      // console.log(this.$children,'新增返回',this.$refs.isnowcom);
    },
  },
  updated() {
    {
      window.scroll(0, 0);
    }
  },
};
</script>
